import UserModel from 'Models/UserModel';

/*
* Если нужны статические ссылки, то указываем ключ links: []
* =======================
* Если нужна динамика, то берем два ключа _dynamic и _defaults
* _dynamic - массив динамических объектов.
* В каждом объекте есть ключ field - какое поле будем проверять
* validator - функция, проверяющая валидность field
* links - массив ссылок для подходящих условий
* =======================
* _defaults - объект значений по умолчанию, если ниодно из условий _dynamic не сработает
* Содержит единственный ключ links - массив ссылок по умолчанию
*/

const company = {
  title: 'Company',
  links: [
    {
      title: 'About Us',
      _href: '/about',
    },
    {
      title: 'Blog',
      _href: '/blog',
    },
    {
      title: 'Contact Us',
      _href: '/contacts',
    },
    {
      title: 'Become a PRO',
      _href: '/become-pro',
    },
    {
      title: 'Cashback',
      _href: '/cashback',
    },
    {
      title: 'Legit',
      _href: '/legit',
    },
  ],
};

const customerService = {
  title: 'Customer Service',
  _dynamic: [
    {
      field: 'user.role',

      validator(value) {
        return [UserModel.ROLES.PRO.id, UserModel.ROLES.PRO_CANDIDATE.id].indexOf(value) > -1;
      },

      links: [
        {
          title: 'My PRO account',
          _href: '/pro/dashboard',
        },
      ],
    },
  ],
  _defaults: {
    links: [
      {
        title: 'Login as PRO',
        _href: '/sign-in',
      },
      {
        title: 'Sitemaps',
        _href: '/sitemaps',
      },
      {
        title: 'Epoch billing support',
        _href: 'https://www.epoch.com',
        isExternalLink: true,
        isNoFollow: true,
        hideOnSidebar: true,
      },
      {
        title: 'FAQ',
        _href: '/faq',
      },
    ],
  },
};

const legal = {
  title: 'Legal & Policies',
  links: [
    {
      title: 'General Terms and Conditions',
      _href: '/agreement',
    },
    {
      title: 'Terms of Services for Coaches',
      _href: '/agreement/coach',
    },
    {
      title: 'Terms of Services for Customers',
      _href: '/agreement/customer',
    },
    {
      title: 'Privacy policy',
      _href: '/privacy',
    },
    {
      title: 'Cookie policy',
      _href: '/cookie',
    },
  ],
};

export const StaticLinksCompany = company;
export const StaticLinksCustomerService = customerService;
export const StaticLinksLegal = legal;

export default [
  company,
  customerService,
  legal,
];
